import React from "react";
import Tabs from "./Tabs";
import TabsTermeChianciano from "./TabsTermeChianciano";

export default function TabRouter(props) {
    const { hasOrders, defaultTab, restaurant } = props;

    return restaurant.token === "3TxGx9xEs" ?
        <TabsTermeChianciano hasOrders={hasOrders}></TabsTermeChianciano> :
        <Tabs hasOrders={hasOrders} defaultTab={defaultTab}></Tabs>;
}
